import React, { useEffect, useState } from "react";
import './LeadsUpdatedVersion.css';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import RatingComponent from "./Rating";
import Swal from "sweetalert2";
import RatingEditComponent from "./RatingEdit";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { motion } from "framer-motion";
import { decryptToken } from "../utils/getToken";

const getEstimatedDeliveryDate = (daysToAdd) => {
    const date = new Date();
    date.setDate(date.getDate() + Number(daysToAdd));
    return date.toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
    });
};

const convertToINRWords = (amount) => {
    const words = [
        "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
        "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
        "Sixteen", "Seventeen", "Eighteen", "Nineteen"
    ];
    const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

    const numToWords = (num) => {
        if (num < 20) return words[num];
        if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? " " + words[num % 10] : "");
        if (num < 1000) return words[Math.floor(num / 100)] + " Hundred" + (num % 100 !== 0 ? " and " + numToWords(num % 100) : "");
        if (num < 100000) return numToWords(Math.floor(num / 1000)) + " Thousand" + (num % 1000 !== 0 ? " " + numToWords(num % 1000) : "");
        if (num < 10000000) return numToWords(Math.floor(num / 100000)) + " Lakh" + (num % 100000 !== 0 ? " " + numToWords(num % 100000) : "");
        return numToWords(Math.floor(num / 10000000)) + " Crore" + (num % 10000000 !== 0 ? " " + numToWords(num % 10000000) : "");
    };

    if (isNaN(amount)) return "";

    const wholePart = Math.floor(amount);
    const result = numToWords(wholePart);

    return `Rupees ${result} Only`;
};

const formatDateToReadable = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
    });
};
export const safeParseJson = (value, fallback = []) => {
    try {
        let parsed = typeof value === "string" ? JSON.parse(value) : value;
        if (typeof parsed === "string") parsed = JSON.parse(parsed); // handle double‑encoded
        return parsed || fallback;
    } catch {
        return fallback;
    }
};
const formatIndianCurrency = (value) => {
    const num = value.replace(/,/g, ''); // Remove commas
    if (!/^\d+$/.test(num)) return value; // Only format if valid number
    return Number(num).toLocaleString('en-IN');
};

const numberToWords = (num) => {
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
        'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen',
        'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const inWords = (n) => {
        if ((n = n.toString()).length > 9) return 'Overflow';
        const nNum = ('000000000' + n).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!nNum) return;
        let str = '';
        str += nNum[1] !== '00' ? (a[Number(nNum[1])] || b[nNum[1][0]] + ' ' + a[nNum[1][1]]) + ' Crore ' : '';
        str += nNum[2] !== '00' ? (a[Number(nNum[2])] || b[nNum[2][0]] + ' ' + a[nNum[2][1]]) + ' Lakh ' : '';
        str += nNum[3] !== '00' ? (a[Number(nNum[3])] || b[nNum[3][0]] + ' ' + a[nNum[3][1]]) + ' Thousand ' : '';
        str += nNum[4] !== '0' ? a[Number(nNum[4])] + ' Hundred ' : '';
        str += nNum[5] !== '00' ? ((str !== '') ? 'and ' : '') + (a[Number(nNum[5])] || b[nNum[5][0]] + ' ' + a[nNum[5][1]]) + ' ' : '';
        return str.trim() + ' Rupees Only';
    };

    return inWords(num.replace(/,/g, ''));
};


const OrderUpdatedVersionCards = (
    { leads, setLeads, selectedLeads, setSelectedLeads, currentPage, newlyAssignedLeads, setNewlyAssignedLeads, alreadyAssignedLeads, setAlreadyAssignedLeads, leadsDataMain }) => {
    const [starredLeads, setStarredLeads] = useState({});
    const [showQuotationModal, setShowQuotationModal] = useState(false);
    const [openCardId, setOpenCardId] = useState(null);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [showReminderModal, setShowReminderModal] = useState(false);
    const [showNoteModal, setShowNoteModal] = useState(false);
    const [pricePerUnit, setPricePerUnit] = useState("");
    const [quantity, setQuantity] = useState(1);
    const [showGST, setShowGST] = useState(false);
    const [gst, setGst] = useState("");
    const [showDiscount, setShowDiscount] = useState(false);
    const [discount, setDiscount] = useState("");
    const [productName, setProductName] = useState("");
    const [addNote, setAddNote] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedTime, setSelectedTime] = useState("");
    const [notes, setNotes] = useState("");
    const [clickedContact, setClickedContact] = useState(false);
    const [showEnquiryModalEdit, setShowEnquiryModalEdit] = useState(false);
    const [showProductModalEdit, setShowProductModalEdit] = useState(false);
    const [products, setProducts] = useState([])
    const [isModalOpen, setModalOpen] = useState(false);
    const [notesData, setNotesData] = useState([]);
    const [leadsData, setLeadsData] = useState({})
    const [leadStatus, setLeadStatus] = useState("");
    const navigate = useNavigate();
    const [showRatingPopup, setShowRatingPopup] = useState(false);
    const [selectedLeadForRating, setSelectedLeadForRating] = useState(null);
    const [services, setServices] = useState([]);
    const [customTime, setCustomTime] = useState(null);
    const [customDate, setCustomDate] = useState(null);
    const [employeeViewFilter, setEmployeeViewFilter] = useState(null);
    const [namemain, setNameMain] = useState("")
    const userData = getDecryptedUserFromCookie("gta_mainstateuser");
    const token = decryptToken("accessToken") || ""
    const [formData, setFormData] = useState({
        id: "",
        name: "",
        mobile: "",
        business_name: "",
        address: "",
        city: "",
        pincode: "",
        parent_name: "",
        remainder_date: "",
        remainder_time: "",
        type_customer: "",
        remark: "",
        email: "",
        enquiry_source: "",
        borrowAmount: ""
    })
    const [openCardStates, setOpenCardStates] = useState({});
    const [shareAComponent, setShareAComponent] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);
    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const [showLeadsdetailsModal, setShwoLeadsDetailsModal] = useState(false);
    const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
    const [groupedModal, setShowGroupedModal] = useState(false)

    const openLeadsDetails = () => {
        setShwoLeadsDetailsModal(true);
    };

    const closeLeadsDetails = () => {
        setSelectedLeadId(null);
    };

    const handleOpenRatingModal = (lead) => {
        setSelectedLead(lead); // store full lead (includes lead.rating)
        setShareAComponent(true); // open modal
    };

    const url = process.env.REACT_APP_LINK
    const BASE_URL = `${url}`

    // const isOpen = openCardId === lead.id;

    const openRatingPopup = (lead) => {
        setSelectedLeadForRating(lead);
        setShowRatingPopup(true);
    };

    // const toggleDetails = (leadId) => {
    //     setOpenCardId(prevId => (prevId === leadId ? null : leadId));
    // };

    const toggleDetails = (leadId) => {
        setOpenCardStates(prev => ({
            ...prev,
            [leadId]: !prev[leadId]
        }));
    };

    const numberToWords = (num) => {
        const a = [
            '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven',
            'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen',
            'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
        ];
        const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (n) => {
            n = Math.floor(n); // Ensure it's a whole number

            if (n === 0) return 'Zero';
            if (n < 20) return a[n];
            if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
            if (n < 1000) return a[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' and ' + convert(n % 100) : '');
            if (n < 100000) return convert(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 ? ' ' + convert(n % 1000) : '');
            if (n < 10000000) return convert(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 ? ' ' + convert(n % 100000) : '');
            return convert(Math.floor(n / 10000000)) + ' Crore' + (n % 10000000 ? ' ' + convert(n % 10000000) : '');
        };

        if (isNaN(num) || num === null) return 'Invalid Number';

        return convert(num);
    };




    const closeRatingPopup = () => {
        setShowRatingPopup(false);
        setSelectedLeadForRating(null);
    };

    const openEnquiryModalEdit = () => {
        setShowEnquiryModalEdit(true);
    };

    const closeEnquiryModalEdit = () => {
        setShowEnquiryModalEdit(false);
        // fetchLeadsData();
    };

    const closeProductModalEdit = () => {
        setShowProductModalEdit(false);
        // fetchLeadsData();
    };

    const closeReminderModal = () => {
        setShowReminderModal(false);
        setSelectedDate(null);
        setSelectedTime(null);
        setCustomTime(null);
        setCustomDate(null);
    };

    const handleDateSelection = (date) => {
        setSelectedDate(date);
        setSelectedTime(null); // Reset time on new date
        setCustomTime(null);
    };

    const getRelativeTime = (timestamp) => {
        if (!timestamp) return "Not Available";

        const pastTime = moment(timestamp).tz("Asia/Kolkata"); // parse ISO and convert to IST
        const now = moment().tz("Asia/Kolkata");

        if (!pastTime.isValid()) return "Invalid date";

        const duration = moment.duration(now.diff(pastTime));

        if (duration.asSeconds() < 60) {
            const seconds = Math.floor(duration.asSeconds());
            return `${seconds} second${seconds !== 1 ? 's' : ''} ago`;
        } else if (duration.asMinutes() < 60) {
            const minutes = Math.floor(duration.asMinutes());
            return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
        } else if (duration.asHours() < 24) {
            const hours = Math.floor(duration.asHours());
            return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
        } else if (duration.asDays() < 7) {
            const days = Math.floor(duration.asDays());
            return `${days} day${days !== 1 ? 's' : ''} ago`;
        } else if (duration.asWeeks() < 4) {
            const weeks = Math.floor(duration.asWeeks());
            return `${weeks} week${weeks !== 1 ? 's' : ''} ago`;
        } else if (duration.asMonths() < 12) {
            const months = Math.floor(duration.asMonths());
            return `${months} month${months !== 1 ? 's' : ''} ago`;
        } else {
            const years = Math.floor(duration.asYears());
            return `${years} year${years !== 1 ? 's' : ''} ago`;
        }
    };



    const openQuotationModal = (lead) => {
        setShowQuotationModal(true);
        setLeadsData(lead);
    };

    const closeQuotationModal = () => {
        setShowQuotationModal(false);
    };

    const openPreviewModal = () => {
        setShowPreviewModal(true);
    };
    const closePreviewModal = () => {
        setShowPreviewModal(false);
    };

    const openReminderModal = () => {
        setShowReminderModal(true);
    }


    const openNoteModal = (lead) => {
        setShowNoteModal(true);
        setLeadsData(lead);
    };

    const closeNoteModal = () => {
        setShowNoteModal(false);
    };


    const handleClickContact = () => {
        setClickedContact(true);
    };


    // Handle selection of individual leads
    // const handleSelectLead = (id) => {
    //     setSelectedLeads(prevSelected => {
    //         const updatedSelections = prevSelected[currentPage] ? [...prevSelected[currentPage]] : [];

    //         if (updatedSelections.includes(id)) {
    //             // Remove if already selected
    //             return {
    //                 ...prevSelected,
    //                 [currentPage]: updatedSelections.filter(leadId => leadId !== id),
    //             };
    //         } else {
    //             // Add if not selected
    //             return {
    //                 ...prevSelected,
    //                 [currentPage]: [...updatedSelections, id],
    //             };
    //         }
    //     });
    // };

    const handleSelectLead = (id) => {
        setSelectedLeads(prevSelected => {
            const updatedSelections = prevSelected[currentPage] ? [...prevSelected[currentPage]] : [];

            if (updatedSelections.includes(id)) {
                // ✅ Remove color from newly assigned leads when deselected
                setNewlyAssignedLeads((prev) => prev.filter((leadId) => leadId !== id));
                setAlreadyAssignedLeads((prev) => prev.filter((leadId) => leadId !== id));

                return {
                    ...prevSelected,
                    [currentPage]: updatedSelections.filter(leadId => leadId !== id),
                };
            } else {
                return {
                    ...prevSelected,
                    [currentPage]: [...updatedSelections, id],
                };
            }
        });
    };


    const toggleSelection = (id) => {
        setSelectedLeads((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter(leadId => leadId !== id) // Remove if already selected
                : [...prevSelected, id] // Add if not selected
        );
    };


    // Handle Select All functionality
    useEffect(() => {
        if (selectedLeads.length === leads.length && leads.length > 0) {
            setSelectedLeads(leads.map(lead => lead.id)); // Select all
        }
    }, [leads]);

    // const toggleStarred = (id) => {
    //     setStarredLeads((prev) => ({ ...prev, [id]: !prev[id] }));
    // };

    const toggleStarred = async (lead) => {
        try {
            const response = await fetch(`${url}/leads/toggle-starred/${lead.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ star: !lead.star }), // Toggle the starred value
            });

            if (response.ok) {
                const updatedLead = await response.json();
                // Update state to reflect the change
                setLeads((prevLeads) =>
                    prevLeads.map((l) => (l.id === lead.id ? { ...l, star: updatedLead.star } : l))
                );
                console.log(`Star status updated for lead ID: ${lead.id}`);
            }
        } catch (error) {
            console.error("Error updating starred status:", error);
        }
    };






    // Calculate total amount
    const calculateTotal = () => {
        let basePrice = pricePerUnit;

        let discountAmount = 0;
        if (showDiscount && discount > 0) {
            discountAmount = (basePrice * discount) / 100;
        }

        let gstAmount = 0;
        if (showGST && gst > 0) {
            gstAmount = (basePrice * gst) / 100;
        }

        const total = (basePrice - discountAmount) + gstAmount;

        return total.toFixed(2);
    };

    const handleContactClick = async (lead, contactType) => {
        try {
            const response = await fetch(`${url}/payment/update-mark/${lead.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            });

            console.log(`Mark updated for lead ID: ${lead.id}`);
            if (response.ok) {
                fetchLeads();
            }
            // Redirect based on contact type
            if (contactType === "phone") {
                window.location.href = `tel:${lead.mobile}`;
            } else if (contactType === "whatsapp") {
                const whatsappNumber = lead.mobile.replace(/\D/g, ""); // Ensure only numbers
                window.open(`https://wa.me/${whatsappNumber}`, "_blank");
            } else if (contactType === "email") {
                window.location.href = `mailto:${lead.age}`;
            }

        } catch (error) {
            console.error("Error updating mark:", error);
        }
    };

    const fetchLeads = async () => {
        try {
            const response = await fetch(`${url}/payment/assignedorder`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            const res = await response.json();
            const parsedOrders = res.map(order => ({
                ...order,
                cart_products: typeof order.cart_products === 'string' ? JSON.parse(order.cart_products) : order.cart_products,
                shipping_address: typeof order.shipping_address === 'string' ? JSON.parse(order.shipping_address) : order.shipping_address,
                billing_address: typeof order.billing_address === 'string' ? JSON.parse(order.billing_address) : order.billing_address,
            }));
            setLeads(parsedOrders.reverse());


        } catch (error) {
            console.error("Error fetching leads:", error);
        }
    };

    const convertToIST = (utcDateString) => {
        if (!utcDateString) return "Invalid Date";

        const date = new Date(utcDateString);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            // day: "2-digit",
            // month: "short",
            // year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    const convertToISTUtc = (utcDateString) => {
        if (!utcDateString) return "Invalid Date";

        const date = new Date(utcDateString);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    const convertToISTMain = (utcDateString) => {
        if (!utcDateString) return "Invalid Date";

        const date = new Date(utcDateString);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            // day: "2-digit",
            // month: "short",
            // year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            // second: "2-digit",
            hour12: true
        });
    };



    const handleNotesSubmit = async () => {
        try {
            const full_name = userData.firstName + " " + userData.lastName
            const response = await fetch(`${url}/order-note/staff`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    remark: notes,
                    property_id: leadsData.id,
                    property: leadsData.business_name,
                    phone: full_name,
                    user_id: userData.main_id
                })
            })
            if (response.ok) {
                const res = await response.json();
                console.log(res);
                setNotes("")
                fetchNotes(leadsData.id);
                fetchLeads();
                toast.success("Note added successfully");
                closeNoteModal();
            }
        } catch (error) {
            console.log(error);
            toast.error(error);
        }
    }

    const fetchNotes = async (id) => {
        try {
            const response = await fetch(`${url}/order-note/staff/all/${(id)}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            const res = await response.json();

            setNotesData(res);
            console.log(res);
        } catch (error) {
            console.log(error);
        }
    }

    const handleStatusChange = async (newStatus, lead) => {
        setIsUpdatingStatus(true);
        try {
            // Map status → date field in DB
            const statusDateMap = {
                "Delivered": "delivery_date",
                "Processing": "processing_date",
                "Packed": "packed_date",
                "Shipped": "shipped_date",
                "Out for delivery": "out_deliverydate"
            };

            const dateField = statusDateMap[newStatus];
            const now = new Date().toISOString(); // current datetime

            const body = {
                orderStatus: newStatus,
                ...(dateField && { [dateField]: now }) // dynamically add correct field
            };

            const response = await fetch(`${url}/payment/${lead.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(body)
            });

            if (response.ok) {
                toast.success("Status updated successfully");

                // ✅ Update local state
                setLeads(prev =>
                    prev.map(item =>
                        item.id === lead.id
                            ? { ...item, orderStatus: newStatus, ...(dateField && { [dateField]: now }) }
                            : item
                    )
                );
            } else {
                const err = await response.json();
                toast.error(err.message || "Failed to update status");
            }
        } catch (err) {
            console.error("Error updating status:", err);
            toast.error("An error occurred while updating status");
        } finally {
            setIsUpdatingStatus(false);
        }
    };


    const handleSendQuotation = async () => {
        const payload = {
            user_id: leadsData.id,
            user_name: leadsData.name === "" ? leadsData.business_name : leadsData.name,
            service_name: productName,
            quantity,
            price_per_unit: pricePerUnit,
            gst,
            discount,
            notes: addNote,
            staff_name: "Admin",
            total_amount: calculateTotal(),
        };

        try {
            const response = await fetch(`${url}/quotation`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();
            if (response.ok) {
                handleWhatsAppSend(payload)
                toast.success("Quotation sent and saved successfully!");
                // Optionally close modal or reset fields

            } else {
                toast.error(data.message || "Failed to send quotation.");
            }
        } catch (err) {
            console.error("Error sending quotation:", err);
            toast.error("Something went wrong while sending the quotation.");
        }
    };

    const handleWhatsAppSend = (lead) => {
        const totalFormatted = `₹${calculateTotal().toLocaleString("en-IN")}`;

        const message = `
      Dear ${lead.user_name},
      Greetings from ${userData.full_name}!
      
      Here's the information you requested:
      
      • Building/Project Name: ${lead.service_name}
      • Carpet Area: ${lead.quantity} sq.ft
      • Total Price: ${totalFormatted}
      • Note: ${lead.notes}
      
      
      Thank you!
        `.trim();

        const phone = leadsData.mobile.replace(/\D/g, "");
        const fullPhone = phone.startsWith("91") ? phone : `91${phone}`;
        const encodedMessage = encodeURIComponent(message);

        const url = `https://api.whatsapp.com/send?phone=${fullPhone}&text=${encodedMessage}`;

        window.open(url, "_blank");
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        // For mobile number validation
        if (name === "mobile") {
            // Allow only digits
            const numericValue = value.replace(/\D/g, "");

            // Check if it starts with 6-9 and is up to 10 digits
            if (numericValue === "" || /^[6-9]\d{0,9}$/.test(numericValue)) {
                setFormData((prevData) => ({
                    ...prevData,
                    [name]: numericValue,
                }));
            }

            return; // Exit to avoid setting invalid mobile number
        }

        // For other fields
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${url}/leads/change/${formData.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(formData)
            })
            const res = await response.json();
            if (response.ok) {
                fetchLeads();
                closeEnquiryModalEdit();
            }
            console.log(res);
        } catch (error) {
            console.log(error);
        }
    }


    useEffect(() => {
        console.log("Newly Assigned Leads Updated:", newlyAssignedLeads);
    }, [newlyAssignedLeads]);

    const formatIndianCurrency = (amount) => {
        return Number(amount).toLocaleString('en-IN');
    };

    const handleDeleteLead = async (id, name, business) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: `You want to delete ${name === "" ? business : name}  permanently!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            try {
                await fetch(`${BASE_URL}/payment/${id}`, {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                fetchLeads();
                Swal.fire("Deleted!", `${name === "" ? "User" : name - business} has been deleted.`, "success");
            } catch (error) {
                console.error("Error deleting property:", error);
                Swal.fire("Error!", "Failed to delete the property. Try again later.", "error");
            }
        }
    }

    const updateLead = (id, updatedFields) => {
        setLeads(prevLeads =>
            prevLeads.map(lead =>
                lead.id === id ? { ...lead, ...updatedFields } : lead
            )
        );
    };

    const [itemsOptions, setItemsOptions] = useState([]);

    const fetchServiceData = async () => {
        try {
            const res = await fetch(`${url}/offerings/all/${userData.main_id}`);
            const data = await res.json();
            setItemsOptions(data);
        } catch (error) {
            console.error("Error fetching offerings:", error);
        }
    };


    useEffect(() => {
        fetchNotes();
        fetchServiceData();
    }, [])


    return (
        <>
            {isUpdatingStatus && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(255,255,255,0.8)",
                    zIndex: 9999,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <div className="loader" style={{
                        border: "5px solid #f3f3f3",
                        borderTop: "5px solid #3498db",
                        borderRadius: "50%",
                        width: "50px",
                        height: "50px",
                        animation: "spin 1s linear infinite"
                    }}></div>
                    <p style={{ marginTop: "10px", color: "  #cccccc" }}>...loading</p>
                </div>
            )}

            {
                leads.map((lead) => {
                    const isCardOpen = openCardStates.hasOwnProperty(lead.id)
                        ? openCardStates[lead.id]
                        : lead.mark === "Read"; // default to open if mark is Read
                    // const productcart = JSON.parse(lead?.cart_products)
                    return <div className={`card-rating `} >
                        <div className={`lsuv-card 
    ${alreadyAssignedLeads.includes(lead.id) ? "already-assigned" : ""} 
    ${newlyAssignedLeads.includes(lead.id) ? "" : ""}`}
                            key={lead.id}
                            style={{
                                background:
                                    lead.orderStatus === "Delivered"
                                        ? "  #f6fef2"
                                        : lead.orderStatus === "Cancelled"
                                            ? "#fef5f3"
                                            : "inherit"
                            }}
                        >
                            <div className="lsuv-card__header">
                                <div className="lsuv-card__row lsuv-card__row--top">
                                    <div className="lsuv-card__left">
                                        <div className="lsuv-card__checkbox">
                                            <input type="checkbox"
                                                checked={selectedLeads[currentPage]?.includes(lead.id) || false}
                                                onChange={() => handleSelectLead(lead.id)}
                                            />
                                        </div>
                                        <div className="lsuv-card__status">
                                            <span className={`lsuv-status ${lead.mark === "Read" ? "lsuv-status--read" : "lsuv-status--unread"}`}>
                                                {lead.mark === "New" ? lead.mark : (lead.rate_message === "" || lead.rate_message === null) ? lead.mark : lead.rate_message}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="lsuv-card__right">
                                        <span className="lsuv-card__timestamp">{convertToISTUtc(lead.createdAt)}</span>
                                    </div>
                                </div>

                                <div className="lsuv-card__row lsuv-card__row--bottom">
                                    <div className="lsuv-card__left">
                                        {/* <div className="lsuv-card__star-icon" onClick={() => toggleStarred(lead)}>
                                            <i
                                                className={lead.star ? "fa-solid fa-star starred" : "fa-regular fa-star unstarred"}
                                            ></i>
                                        </div> */}
                                        <div className="lsuv-card__title">
                                            <p>{lead.user_name} <span>({lead.user_id ? (lead.user_id) : null})</span></p>
                                            {/* <p>Company name</p> */}
                                        </div>
                                    </div>
                                    <div className="lsuv-card__right">
                                        <div className="lsuv-card__contact-icons">
                                            {
                                                lead.mobile ? <a
                                                    href="#"
                                                    className={`ls-card-icon ls-call ${clickedContact ? "clicked" : ""}`}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleContactClick(lead, "phone");
                                                    }}
                                                >
                                                    <i className="fas fa-phone"></i>
                                                </a> : null
                                            }
                                            {
                                                lead.email
                                                    ? (
                                                        <a
                                                            href="#"
                                                            className={`ls-card-icon ls-mail ${clickedContact ? "clicked" : ""}`}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleContactClick(lead, "email");
                                                            }}
                                                        >
                                                            <i className="fas fa-envelope"></i>
                                                        </a>
                                                    )
                                                    : lead.email
                                                        ? (
                                                            <a
                                                                href="#"
                                                                className={`ls-card-icon ls-mail ${clickedContact ? "clicked" : ""}`}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleContactClick(lead, "email");
                                                                }}
                                                            >
                                                                <i className="fas fa-envelope"></i>
                                                            </a>
                                                        )
                                                        : null
                                            }
                                            {
                                                lead.mobile ? <a
                                                    href='#'
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={`ls-card-icon ls-whatsapp ${clickedContact ? "clicked" : ""}`}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleContactClick(lead, "whatsapp");
                                                    }}
                                                >
                                                    <i className="fab fa-whatsapp"></i>
                                                </a> : null
                                            }
                                            <a
                                                href="#"
                                                className={`ls-card-icon ls-whatsapp ${clickedContact ? "clicked" : ""}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setSelectedLeadId({
                                                        ...lead,
                                                        cart_products: typeof lead.cart_products === 'string' ? JSON.parse(lead.cart_products) : lead.cart_products,
                                                        billing_address: typeof lead.billing_address === 'string' ? JSON.parse(lead.billing_address) : lead.billing_address,
                                                        shipping_address: typeof lead.shipping_address === 'string' ? JSON.parse(lead.shipping_address) : lead.shipping_address,
                                                    });
                                                    openLeadsDetails();
                                                }}
                                            >
                                                <i className="fas fa-eye"></i>
                                            </a>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="lsuv-middle-footer">
                                <div className="lsuv-card__middle">
                                    <div className="lsuv-card__address">
                                        <p>{lead.address} {lead.city} {lead.pincode}</p>
                                    </div>
                                    {console.log(lead)}
                                    {lead?.name ? (
                                        <div className="lsuv-card__service">
                                            <p><strong>Name:</strong> {lead?.name}</p>
                                        </div>
                                    ) : null}
                                    {lead.order_id ? (
                                        <div className="lsuv-card__service">
                                            <p><strong>Refrence ID:</strong> {lead.order_id}</p>
                                        </div>
                                    ) : null}

                                    {lead.receipt_id ? (
                                        <div className="lsuv-card__service">
                                            <p><strong>Order ID:</strong> {lead.receipt_id}</p>
                                        </div>
                                    ) : null}
                                    {lead.status ? (
                                        <div className="lsuv-card__service">
                                            <p><strong>Payment Status:</strong> {lead.status}</p>
                                        </div>
                                    ) : null}
                                    <div className="lsuv-card__assigned">
                                        {lead.AssignOrders && lead.AssignOrders.length > 0 ? (
                                            <p>
                                                <strong>Assigned to:</strong>{" "}
                                                {lead.AssignOrders.map((assign, index) => (
                                                    <span key={assign.id}>
                                                        {assign.staff_name.replace(/\(ID:.*?\)/, "").trim()}
                                                        {index < lead.AssignOrders.length - 1 ? ", " : ""}
                                                    </span>
                                                ))}
                                            </p>
                                        ) : null}
                                    </div>
                                    {
                                        (lead.remark) ?
                                            <div className="lsuv-card__message">
                                                <p><strong>Message:</strong>{lead.remark}</p>
                                            </div>
                                            : null
                                    }
                                </div>
                                <div className={isCardOpen ? 'lsuv-card__footer-section' : 'lsuv-card__footer-section-hidden'}>
                                    <div className="lsuv-card__action-group">
                                        <div className="lsuv-card__action">
                                            <button className="lsuv-card__btn"
                                                onClick={() => {
                                                    openNoteModal(lead)

                                                    fetchNotes(lead.id)
                                                }}
                                            >
                                                <i className="fa fa-sticky-note"></i> Add notes
                                            </button>
                                        </div>
                                        {/* <div className="lsuv-card__action">
                                            <button className="lsuv-card__btn"
                                                onClick={() => openReminderModal()}>
                                                <i className="fa fa-bell"></i> Add reminder
                                            </button>
                                        </div> */}
                                        {/* <div className="lsuv-card__action">
                                            <button className="lsuv-card__btn"
                                                onClick={() => openRatingPopup(lead)}>
                                                <i className="fa fa-star"></i> Ask rating
                                            </button>
                                        </div> */}
                                        <div className="lsuv-card__status-select">
                                            <select
                                                name="extra"
                                                value={lead.orderStatus || ""}
                                                id="status"
                                                className="lsuv-card__select"
                                                onChange={(e) => handleStatusChange(e.target.value, lead)}
                                            >
                                                {/* "Pending", "Processing","Packed", "Shipped", "Out for delivery",  "Delivered", "Cancelled" */}
                                                <option value="">Select</option>
                                                <option value="Pending">Pending</option>
                                                <option value="Processing">Processing</option>
                                                <option value="Packed">Packed</option>
                                                <option value="Shipped">Shipped</option>
                                                <option value="Out for delivery">Out for delivery</option>
                                                <option value="Delivered">Delivered</option>
                                                <option value="Cancelled">Cancelled</option>
                                            </select>
                                        </div>
                                        {/* <div className="lsuv-card__action">
                                            <button className="lsuv-card__btn"
                                                onClick={() => {
                                                    setFormData({
                                                        id: lead.id,
                                                        name: lead.name,
                                                        mobile: lead.mobile,
                                                        property_name: lead.business_name,
                                                        address: lead.address,
                                                        city: lead.city,
                                                        pincode: lead.pincode,
                                                        parent_name: lead.parent_name,
                                                        remainder_date: lead.remainder_date,
                                                        remainder_time: lead.remainder_time,
                                                        type_customer: lead.type_customer,
                                                        remark: lead.remark,
                                                        email: lead.email,
                                                        enquiry_source: lead.enquiry_source,
                                                        borrowAmount: lead.borrowAmount
                                                    })
                                                    setShowEnquiryModalEdit(true)
                                                }}>
                                                <i className="fa fa-edit"></i> Edit
                                            </button>
                                        </div> */}
                                        <div className="lsuv-card__action">
                                            <button className="lsuv-card__btn"
                                                onClick={() => {
                                                    setShowProductModalEdit(true)
                                                    setProducts(JSON.parse(lead.cart_products))
                                                }}>
                                                <i class="fa-solid fa-warehouse"></i> Products
                                            </button>
                                        </div>
                                    </div>


                                    {
                                        lead.type_customer ?
                                            <div className="lsuv-card__source-info">
                                                <p><strong>Customer Type:</strong> {lead.type_customer}</p>
                                            </div>
                                            : null
                                    }

                                    {
                                        lead.enquiry_source ?
                                            <div className="lsuv-card__source-info">
                                                <p><strong>Loan Type:</strong> {lead.enquiry_source}</p>
                                            </div>
                                            : null
                                    }
                                    {
                                        lead.source ?
                                            <div className="lsuv-card__source-info">
                                                <p><strong>Source:</strong> {lead.source}</p>
                                            </div>
                                            : null
                                    }
                                    {lead.borrowAmount ? (
                                        <div className="lsuv-card__source-info">
                                            <p>
                                                <strong>Borrow Amount:</strong> {numberToWords(Number(lead.borrowAmount.replace(/,/g, '')))}
                                                (₹ {formatIndianCurrency(Number(lead.borrowAmount.replace(/,/g, '')))})
                                            </p>
                                        </div>
                                    ) : null}
                                    {lead.monthlySalary ? (
                                        <div className="lsuv-card__source-info">
                                            <p>
                                                <strong>Monthly Salary:</strong> {numberToWords(Number(lead.monthlySalary.replace(/,/g, '')))}
                                                (₹ {formatIndianCurrency(Number(lead.monthlySalary.replace(/,/g, '')))})
                                            </p>
                                        </div>
                                    ) : null}

                                </div>
                            </div>

                            <div className="lsuv-card__meta-footer">
                                <div
                                    className="lsuv-card__toggle-details"
                                    onClick={() => toggleDetails(lead.id)}
                                >
                                    {isCardOpen ? 'Hide Details' : 'Show Details'}
                                </div>

                                <div className="connected-delete-crm">
                                    {console.log(lead.connected_time)}
                                    {
                                        lead.connected_time ?
                                            <div className="lsuv-card__connection-info">
                                                <p>Connected {getRelativeTime(lead.connected_time)}</p>
                                            </div>
                                            : null
                                    }
                                    <div className="crm-delete-icon" onClick={() => handleDeleteLead(lead.id, lead.user_name, lead.user_id)}>
                                        <i class="fa-solid fa-trash" title="Delete Lead"></i>
                                    </div>
                                    {
                                        (lead.rating && lead.rate_message) ?
                                            <div className="crm-border-card"></div> : null
                                    }
                                    {
                                        (lead.rating && lead.rate_message) ? <div className="re-rating-btn-crm" onClick={() => handleOpenRatingModal(lead)}>
                                            <p>{lead.rating} <i class="fa-solid fa-star"></i></p>
                                        </div> : null
                                    }
                                </div>

                            </div>
                        </div>

                        {
                            (
                                !lead.rating ||
                                !lead.rate_message
                            ) && lead.mark === "Read" ? <RatingComponent inquiryId={lead.id} mark={lead.mark} leadsDataRatingMain={leadsDataMain}
                                updateLead={updateLead}
                            /> : null

                        }

                        {shareAComponent && selectedLead && selectedLead.id === lead.id &&
                            (lead.mark === "Read") && (
                                <RatingEditComponent
                                    inquiryId={selectedLead.id}
                                    mark={selectedLead.mark}
                                    initialRating={selectedLead.rating}
                                    initialRateMessage={selectedLead.rate_message}
                                    leadsDataMain={leadsDataMain}
                                    updateLead={updateLead}
                                />
                            )}


                    </div>
                })}

            {showRatingPopup && selectedLeadForRating && (
                <div className="ls-modal">
                    <div className="ls-modal-content">
                        <div className="quotation-header">
                            <h2>Send Rating Request</h2>
                            <button className="quotation-close" onClick={closeRatingPopup}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        <p>Choose how you'd like to request a rating from <strong>{selectedLeadForRating.name}</strong>:</p>

                        <div className="rating-options">
                            <button
                                className="whatsapp-btn"
                                onClick={() => {
                                    const message = `Hi ${selectedLeadForRating.name},
                We would greatly appreciate your valuable feedback.
                Please take a moment to leave us a review on Google:
                👉 https://g.page/r/CQccMqyEJYQ7EBM/review
                
                Thank you for your support!`;
                                    const phone = selectedLeadForRating.mobile.replace(/\D/g, "");
                                    const url = `https://wa.me/91${phone}?text=${encodeURIComponent(message)}`;
                                    window.open(url, "_blank");
                                    closeRatingPopup();
                                }}
                            >
                                <i className="fab fa-whatsapp"></i> WhatsApp
                            </button>

                            <button
                                className="sms-btn"
                                onClick={() => {
                                    const smsBody = `Hi ${selectedLeadForRating.name},
                We would greatly appreciate your valuable feedback.
                Please take a moment to leave us a review on Google:
                👉 https://g.page/r/CQccMqyEJYQ7EBM/review
                
                Thank you for your support!`;
                                    window.open(`sms:${selectedLeadForRating.mobile}?body=${encodeURIComponent(smsBody)}`);
                                    closeRatingPopup();
                                }}
                            >
                                <i class="fa-solid fa-envelope"></i>Message
                            </button>

                            {
                                selectedLeadForRating.age ? <button
                                    className="email-btn"
                                    onClick={() => {
                                        const subject = "We’d love your feedback!";
                                        const body = `Hi ${selectedLeadForRating.name},
                \n\nWe would greatly appreciate your valuable feedback.
                Please take a moment to leave us a review on Google:
                👉 https://g.page/r/CQccMqyEJYQ7EBM/review
                
                Thank you for your support!`;
                                        window.location.href = `mailto:${selectedLeadForRating.age}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
                                        closeRatingPopup();
                                    }}
                                >
                                    <i className="fas fa-envelope"></i> Email
                                </button> : null
                            }
                        </div>
                    </div>
                </div>
            )}


            {showQuotationModal && (
                <div className="quotation-modal">
                    <div className="quotation-container">
                        <div className="quotation-header">
                            <h2>Generate and Send Quotation</h2>
                            <button className="quotation-close" onClick={() => setShowQuotationModal(false)}><i className="fa-solid fa-xmark"></i></button>
                        </div>
                        <div className="quotation-content">
                            <div className="quotation-input-grp">
                                <input
                                    type="text"
                                    value={productName}
                                    onChange={(e) => setProductName(e.target.value)}
                                    placeholder="Enter Project/Building Name"
                                />
                            </div>
                            <div className="quotation-input-flex">
                                <div className="quotation-input-grp quotation-price-per-unit">
                                    <label htmlFor="quotation-price-per-unit">Property Price</label>
                                    <input
                                        type="number"
                                        name="quotation-price-per-unit"
                                        value={pricePerUnit}
                                        placeholder="₹1000"
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setPricePerUnit(value === "" ? "" : Number(value));
                                        }}
                                    // onChange={(e) => setPricePerUnit(Number(e.target.value))}
                                    />
                                    {
                                        pricePerUnit > 0 &&
                                        <small style={{ fontSize: "12px", color: "#3399ff", fontWeight: "600", marginTop: "3px" }}>
                                            {convertToINRWords(pricePerUnit)}
                                        </small>
                                    }
                                </div>
                                <div className="quotation-input-grp quotation-quantity">
                                    <label htmlFor="quotation-quantity">Carpet Area</label>
                                    <input
                                        type="number"
                                        name="quotation-quantity"
                                        value={quantity}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setQuantity(value === "" ? "" : Number(value));
                                        }}
                                    />

                                </div>
                            </div>
                            <div className="quotation-input-flex">
                                <div className="quotation-input-grp">
                                    <div className="quotation-toggle">
                                        <label>Add GST (%)</label>
                                        <span className="quotation-toggle-icon" onClick={() => setShowGST(!showGST)}>
                                            <i className={`fas ${showGST ? 'fa-toggle-on' : 'fa-toggle-off'}`}></i>
                                        </span>
                                    </div>
                                    {showGST &&
                                        <input
                                            type="number"
                                            placeholder="GST %"
                                            value={gst}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setGst(value === "" ? "" : Number(value));
                                            }}

                                        />
                                    }
                                </div>
                                <div className="quotation-input-grp">
                                    <div className="quotation-toggle">
                                        <label>Add Discount (%)</label>
                                        <span className="quotation-toggle-icon" onClick={() => setShowDiscount(!showDiscount)}>
                                            <i className={`fas ${showDiscount ? 'fa-toggle-on' : 'fa-toggle-off'}`}></i>
                                        </span>
                                    </div>
                                    {showDiscount &&
                                        <input
                                            type="number"
                                            placeholder="Discount %"
                                            value={discount}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setDiscount(value === "" ? "" : Number(value));
                                            }}

                                        />
                                    }
                                </div>
                            </div>
                            <div className="quotation-input-grp">
                                <input
                                    type="text"
                                    value={addNote}
                                    onChange={(e) => setAddNote(e.target.value)}
                                    placeholder="Add notes"
                                />
                            </div>

                            <div className="quotation-footer">
                                <p className="quotation-total-amt">
                                    <div>Total Amount:</div>
                                    <div>₹{calculateTotal()}</div>
                                </p>
                                <div className="quotation-preview">
                                    <button onClick={() => openPreviewModal()}><i className="fa-solid fa-eye"></i>Preview quote</button>
                                </div>
                                <div onClick={handleSendQuotation} className="quotation-whatsapp">
                                    <button><i className="fa-brands fa-whatsapp"></i>WhatsApp</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {showPreviewModal && (
                <div className="preview-modal">
                    <div className="preview-container">
                        <div className="quotation-header">
                            <h2>Quotation preview</h2>
                            <button className="quotation-close" onClick={closePreviewModal}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        <div className="chat-message">
                            <p>
                                Dear <strong>{leadsData.name === "" ? leadsData.business_name : leadsData.name}</strong>,<br />
                                Greetings from <strong>{userData.full_name}</strong>!<br />
                                Here's the information you requested:<br />
                                <strong>Product Name:</strong>{productName}<br />
                                <strong>Quantity:</strong> {quantity}<br />
                                <strong>Note:</strong>{addNote}<br />
                                <strong>Total Price:</strong> ₹{calculateTotal()}
                            </p>
                        </div>
                        <div className="quotation-footer">
                            <div className="quotation-preview edit-quotation">
                                <button onClick={closePreviewModal}><i className="fa-solid fa-pencil"></i>Edit quote</button>
                            </div>
                            <div className="quotation-whatsapp" onClick={handleSendQuotation} >
                                <button><i className="fa-brands fa-whatsapp"></i> WhatsApp</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showReminderModal && (
                <div className="ls-modal">
                    <div className="ls-modal-content">
                        <div className="quotation-header">
                            <h2>Set reminder</h2>
                            <button className="quotation-close" onClick={closeReminderModal}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>

                        <h2>Select Date</h2>
                        <div className="ls-modal-options">
                            <label className={`ls-radio-option ${selectedDate === "today" ? "selected" : ""}`} onClick={() => handleDateSelection("today")}>
                                Today
                            </label>
                            <label className={`ls-radio-option ${selectedDate === "tomorrow" ? "selected" : ""}`} onClick={() => handleDateSelection("tomorrow")}>
                                Tomorrow
                            </label>
                            <label className={`ls-radio-option ${selectedDate === "pick-date" ? "selected" : ""}`} onClick={() => handleDateSelection("pick-date")}>
                                Pick a Date
                            </label>
                        </div>

                        {/* Show Time Options for Today */}
                        {selectedDate === "today" && (
                            <div className="ls-time-options">
                                <h3>Select Time</h3>
                                <div className="ls-modal-options">
                                    <label className={`ls-radio-option ${selectedTime === "30min" ? "selected" : ""}`} onClick={() => setSelectedTime("30min")}>
                                        In 30 minutes
                                    </label>
                                    <label className={`ls-radio-option ${selectedTime === "2hours" ? "selected" : ""}`} onClick={() => setSelectedTime("2hours")}>
                                        In 2 hours
                                    </label>
                                    <label className={`ls-radio-option ${selectedTime === "custom" ? "selected" : ""}`} onClick={() => setSelectedTime("custom")}>
                                        Pick a Time
                                    </label>
                                </div>
                            </div>
                        )}

                        {/* Show Time Options for Tomorrow */}
                        {selectedDate === "tomorrow" && (
                            <div className="ls-time-options">
                                <h3>Select Time</h3>
                                <div className="ls-modal-options">
                                    <label className={`ls-radio-option ${selectedTime === "10am" ? "selected" : ""}`} onClick={() => setSelectedTime("10am")}>
                                        10:00 AM
                                    </label>
                                    <label className={`ls-radio-option ${selectedTime === "2pm" ? "selected" : ""}`} onClick={() => setSelectedTime("2pm")}>
                                        2:00 PM
                                    </label>
                                    <label className={`ls-radio-option ${selectedTime === "custom" ? "selected" : ""}`} onClick={() => setSelectedTime("custom")}>
                                        Pick a Time
                                    </label>
                                </div>
                            </div>
                        )}

                        {/* Custom Time Picker */}
                        {selectedTime === "custom" && (
                            <div className="ls-time-picker">
                                <input
                                    type="time"
                                    value={customTime || ""}
                                    onChange={(e) => setCustomTime(e.target.value)}
                                />
                            </div>
                        )}

                        {/* Pick Date and Time together */}
                        {selectedDate === "pick-date" && (
                            <>
                                <div className="lsuv-pick-date-time">
                                    <div className="ls-date-picker">
                                        <label>Date</label>
                                        <input
                                            type="date"
                                            value={customDate || ""}
                                            onChange={(e) => setCustomDate(e.target.value)}
                                        />
                                    </div>
                                    <div className="ls-time-picker">
                                        <label>Time</label>
                                        <input
                                            type="time"
                                            value={customTime || ""}
                                            onChange={(e) => setCustomTime(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="ls-modal-action">
                            <button className="ls-modal-cancel" onClick={closeReminderModal}>Cancel</button>
                            <button className="ls-apply-btn" onClick={() => {
                                const finalDate = selectedDate === "pick-date" ? customDate : selectedDate;
                                const finalTime = selectedTime === "custom" ? customTime : selectedTime;
                                console.log("Final Reminder:", { finalDate, finalTime });
                                closeReminderModal();
                            }}>
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showNoteModal && (
                <div className="ls-modal ls-modal-note">
                    <div className="ls-modal-content">
                        <div className="quotation-header">
                            <h2>Set note</h2>
                            <button className="quotation-close" onClick={closeNoteModal}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        {/* <form > */}
                        <div className="ls-modal-options">
                            <textarea
                                placeholder="Write notes..."
                                name="notes"
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                            ></textarea>
                        </div>
                        <div className="ls-modal-action">
                            <button className="ls-modal-cancel" onClick={closeNoteModal}>Cancel</button>
                            <button type="submit" className="ls-apply-btn" onClick={handleNotesSubmit}>Add notes</button>
                        </div>
                        {/* </form> */}
                        {
                            notesData.length > 0 ? <div className="recorded-notes">
                                <div className="quotation-header">
                                    <h2>Recorded notes</h2>
                                </div>
                                <div className="recorded-note-lists">
                                    {notesData.map((ele, idx) => {
                                        const formattedDate = new Date(ele.createdAt).toLocaleString("en-IN", {
                                            timeZone: "Asia/Kolkata",
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            second: "2-digit",
                                            hour12: true
                                        });
                                        return (
                                            <div className="recorded-note-items">
                                                <p className="recorded-note-date-time">
                                                    {formattedDate} (
                                                    {ele.phone === userData.firstName + " " + userData.lastName ? "You" : ele.phone}
                                                    )
                                                </p>

                                                <p className="recorder-note-content">
                                                    {ele.remark}
                                                </p>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div> : null
                        }
                    </div>
                </div>
            )}

            {showEnquiryModalEdit && (
                <div className="ls-enquiry-modal">
                    <div className="ls-enquiry-modal-content">
                        <div className="quotation-header">
                            <h2><i className="fa-solid fa-envelope"></i> New Enquiry</h2>
                            <button className="quotation-close" onClick={closeEnquiryModalEdit}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="ls-form-group">
                                <label>Customer/Business Owner Name</label>
                                <input type="text" name="name" placeholder="Enter full name" value={formData.name} onChange={handleInputChange} />
                            </div>
                            <div className="ls-form-group">
                                <label>Mobile Number*</label>
                                <input
                                    type="text"
                                    name="mobile"
                                    placeholder="Enter mobile number"
                                    value={formData.mobile}
                                    onChange={handleInputChange}
                                    maxLength={10}
                                    required
                                />

                                {formData.mobile.length > 0 && formData.mobile.length < 10 && (
                                    <p style={{ color: "red", fontSize: "12px" }}>
                                        Mobile number must be 10 digits and start with 6, 7, 8, or 9
                                    </p>
                                )}

                            </div>

                            <div className="ls-form-group">
                                <label>Email</label>
                                <input type="email" name="age" placeholder="Enter email address" value={formData.email} onChange={handleInputChange} />
                            </div>
                            <div className="ls-form-group">
                                <label>Business Name</label>
                                <input type="text" name="business_name" placeholder="Enter business name" value={formData.business_name} onChange={handleInputChange} />
                            </div>

                            <div className="ls-form-group">
                                <label>Address</label>
                                <input type="text" name="address" placeholder="Enter address" value={formData.address} onChange={handleInputChange} />
                            </div>

                            <div className="ls-form-row">
                                <div className="ls-form-group">
                                    <label>City</label>
                                    <input type="text" name="city" placeholder="Enter city" value={formData.city} onChange={handleInputChange} />
                                </div>

                                <div className="ls-form-group">
                                    <label>Pincode</label>
                                    <input
                                        type="text"
                                        name="pincode"
                                        placeholder="Enter pincode"
                                        value={formData.pincode}
                                        onChange={handleInputChange}

                                    />

                                </div>

                            </div>
                            <div className="ls-form-group">
                                <label>Loan Type</label>
                                <select className="ls-categoryservice" name="enquiry_source" id="enquiry_source" value={formData.enquiry_source} onChange={handleInputChange}>
                                    <option value="">Select Loan Type</option>
                                    {
                                        itemsOptions.map((service, index) => (
                                            <option key={index} value={service.sports_offered}>{service.sports_offered}</option>
                                        ))}
                                </select>

                            </div>
                            <div className="ls-form-group">
                                <label>Loan Amount</label>
                                <input
                                    type="text"
                                    name="borrowAmount"
                                    placeholder="Enter Loan Amount"
                                    value={formData.borrowAmount}
                                    onChange={(e) => {
                                        const raw = e.target.value.replace(/,/g, '').replace(/\D/g, '');
                                        const formatted = formatIndianCurrency(raw);
                                        setFormData(formatted);
                                    }}
                                />
                                {formData.borrowAmount && (
                                    <p style={{ fontSize: '12px', color: '#555', marginTop: '4px' }}>
                                        <strong>{numberToWords(formData.borrowAmount)}</strong>
                                    </p>
                                )}
                            </div>
                            {/* <div className="ls-form-group">
                                <label>Required Service</label>
                                <select className="ls-categoryservice" name="parent_name" id="service" value={formData.parent_name} onChange={handleInputChange}>
                                    <option value="">What service do you need?</option>
                                    {
                                        services.map((service, index) => (
                                            <option key={index} value={service}>{service}</option>
                                        ))}
                                </select>
                            </div> */}

                            <div className="ls-form-group">
                                <label>Add Note</label>
                                <textarea name="remark" placeholder="Additional notes..." value={formData.remark} onChange={handleInputChange}></textarea>
                            </div>

                            {/* <div className="ls-form-row">
                                <div className="ls-form-group">
                                    <label>Reminder Date</label>
                                    <input type="date" name="remainder_date" value={formData.remainder_date} onChange={handleInputChange} />
                                </div>

                                <div className="ls-form-group">
                                    <label>Reminder Time</label>
                                    <input type="time" name="remainder_time" value={formData.remainder_time} onChange={handleInputChange} />
                                </div>
                            </div> */}

                            <div className="ls-form-group">
                                <label>Enquiry Source</label>
                                <input type="text" name="enquiry_source" placeholder="Where did you hear about us?" value={formData.enquiry_source} onChange={handleInputChange} />
                            </div>

                            <div className="ls-form-group">
                                <label>Type of Customer</label>
                                <div className="ls-radio-group">
                                    <label className={`ls-radio-option ${formData.type_customer === "Business" ? "selected" : ""}`} onClick={handleInputChange}>
                                        <input type="radio" name="type_customer" value="Business" checked={formData.type_customer === "new"} readOnly /> Business
                                    </label>
                                    <label className={`ls-radio-option ${formData.type_customer === "Salaried" ? "selected" : ""}`} onClick={handleInputChange}>
                                        <input type="radio" name="type_customer" value="Salaried" checked={formData.type_customer === "Salaried"} readOnly /> Salaried
                                    </label>
                                </div>
                            </div>
                            <div className="ls-modal-action">
                                <button className="ls-modal-cancel" onClick={closeEnquiryModalEdit}>Cancel</button>
                                <button className="ls-apply-btn">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {showProductModalEdit && (
                <div className="ls-enquiry-modal order-preview-modal">
                    <div className="ls-enquiry-modal-content">
                        <div className="quotation-header">
                            <h2><i class="fa-solid fa-warehouse"></i> Products</h2>
                            <button className="quotation-close" onClick={closeProductModalEdit}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        <div className="allorder-listhbtecom">
                            {products && products.length > 0 ? (
                                products.map((product, idx) => (
                                    <div key={idx} className="order-product-perfume">
                                        <img
                                            src={`${url}${product.product_image}`}
                                            alt={product.product_name}
                                            className="order-product-image-perfume"
                                        />
                                        <div className="order-product-details-perfume">
                                            <p className="order-product-name-perfume">{product.product_name}</p>
                                            <p>Price: ₹{product.product_saleprice}</p>
                                            <p>Quantity: {product.quantity}</p>
                                            {product.variation_attributes &&
                                                Object.entries(product.variation_attributes).map(([key, value]) => (
                                                    <p key={key}><strong>{key}:</strong> {value}</p>
                                                ))
                                            }
                                            {/* <button className="order-view-product-btn-perfume" onClick={() => navigate(`/product/${product.product_name}/${product.product_id}`)}>View Product</button> */}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>No products found in this order.</p>
                            )}
                        </div>
                    </div>
                </div>
            )}


            {selectedLeadId && (
                <div className="ls-enquiry-modal">
                    <div className="ls-enquiry-modal-content">
                        <div className="quotation-header">
                            <h2>Order Details</h2>
                            <button className="quotation-close" onClick={closeLeadsDetails}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>

                        <div className="lead-details-list-crm">
                            <div><strong>Order ID:</strong> {selectedLeadId?.receipt_id}</div>
                            <div><strong>Reference ID:</strong> {selectedLeadId?.order_id}</div>
                            <div><strong>Status:</strong> {selectedLeadId?.status}</div>
                            <div><strong>Order Status:</strong> {selectedLeadId?.orderStatus}</div>
                            {
                                selectedLeadId?.payment_mode &&
                                <div><strong>Payment Mode:</strong> {selectedLeadId?.payment_mode}</div>
                            }
                            {
                                selectedLeadId?.totatotalAmountbeforePay || selectedLeadId?.amountbeforediscount &&
                                <div><strong>Total Amount:</strong> ₹{selectedLeadId?.totalAmountbeforePay || selectedLeadId?.amountbeforediscount}</div>
                            }
                            {
                                selectedLeadId?.deliveryCharge &&
                                <div><strong>Delivery Charge:</strong> ₹{selectedLeadId?.deliveryCharge}</div>
                            }

                            {
                                selectedLeadId?.payment_mode === "Pay on delivery" ? <div><strong>Amount Paid:</strong> ₹{selectedLeadId?.amountafterdiscount}</div> : null
                            }
                            {
                                selectedLeadId?.payment_mode === "NA" ? <div><strong>Amount:</strong> ₹{selectedLeadId?.amountafterdiscount}</div> : null
                            }

                            {
                                selectedLeadId?.payment_mode === "Pay on delivery" ? <div><strong>Remaining Amount:</strong> ₹{selectedLeadId?.remaining_amount}</div> : null
                            }
                            {
                                selectedLeadId?.discountprice && <div><strong>Discount:</strong> ₹{selectedLeadId?.discountprice}</div>
                            }
                            {
                                (selectedLeadId?.gstamount && userData.category === "Restaurant") ? <div><strong>Gst Amount:</strong> ₹{parseFloat(selectedLeadId?.gstamount) * (parseFloat(selectedLeadId.guestVeg || 0) + parseFloat(selectedLeadId.guestNonVeg || 0))}</div>
                                    : <div><strong>Gst Amount:</strong> ₹{selectedLeadId?.gstamount || 0}</div>
                            }
                            {
                                selectedLeadId?.gstpercent && <div><strong>Gst Percent:</strong> {selectedLeadId?.gstpercent || 0}%</div>
                            }
                            {selectedLeadId?.delivery_date && (
                                <div>
                                    <strong>Delivery Date:</strong> {formatDateToReadable(selectedLeadId.delivery_date)}
                                </div>
                            )}
                            <div><strong>Coupon Applied:</strong> {selectedLeadId?.couponapplied ? "Yes" : "No"}</div>
                            {
                                selectedLeadId?.billing_address?.new_address && <div><strong>Billing Address:</strong> {selectedLeadId?.billing_address?.new_address}, {selectedLeadId?.billing_address?.city} - {selectedLeadId?.billing_address?.pincode}</div>
                            }

                            {
                                selectedLeadId?.shipping_address?.new_address && <div><strong>Shipping Address:</strong> {selectedLeadId?.shipping_address?.new_address}, {selectedLeadId?.shipping_address?.city} - {selectedLeadId?.shipping_address?.pincode}</div>
                            }

                            {
                                selectedLeadId?.guestVeg && <div><strong>Guest Veg:</strong> {selectedLeadId?.guestVeg}</div>
                            }
                            {
                                selectedLeadId?.guestNonVeg && <div><strong>Guest NonVeg:</strong> {selectedLeadId?.guestNonVeg}</div>
                            }
                            {
                                selectedLeadId?.user_gstNo && <div><strong>User GST:</strong> {selectedLeadId?.user_gstNo}</div>
                            }
                            {
                                selectedLeadId?.customer_note && <div><strong>Customer Note:</strong> {selectedLeadId?.customer_note}</div>
                            }
                            {
                                userData.category === "Restaurant" ? <div><strong>Total Amount:</strong> ₹{(
                                    (
                                        // Step 1: Subtract delivery charge from amount
                                        (parseFloat(selectedLeadId.amountafterdiscount || 0) - parseFloat(selectedLeadId.deliveryCharge || 0)) *
                                        (parseFloat(selectedLeadId.guestVeg || 0) + parseFloat(selectedLeadId.guestNonVeg || 0))
                                        ||
                                        (parseFloat(selectedLeadId.totalAfterDiscount || 0) - parseFloat(selectedLeadId.deliveryCharge || 0)) *
                                        (parseFloat(selectedLeadId.guestVeg || 0) + parseFloat(selectedLeadId.guestNonVeg || 0))
                                    )
                                    + parseFloat(selectedLeadId.deliveryCharge || 0) // Step 2: Add delivery charge back
                                ).toFixed(2)} (includes GST and delivery if applied)</div> : null
                            }



                            <div><strong>Ordered Products:</strong></div>
                            {selectedLeadId?.cart_products?.map((product, index) => (
                                <div key={index} className="order-product-perfume">
                                    <img
                                        src={`${url}${product.product_image}`}
                                        alt={product.product_name}
                                        className="order-product-image-perfume"
                                    />
                                    <div>
                                        <p><strong>Name:</strong> {product.product_name}</p>
                                        <p><strong>Sale Price:</strong> ₹{product.product_saleprice}</p>
                                        <p><strong>SKU:</strong> {product.product_sku}</p>
                                        <p><strong>Delivery Estimate:</strong> {product.delivery_days
                                            ? `${getEstimatedDeliveryDate(product.delivery_days)} to ${getEstimatedDeliveryDate(Number(product.delivery_days) + 4)}`
                                            : "N/A"}</p>

                                        <p><strong>Quantity:</strong> {product.quantity}</p>

                                        {product.variation_attributes &&
                                            Object.entries(product.variation_attributes).map(([key, value]) => (
                                                <p key={key}><strong>{key}:</strong> {value}</p>
                                            ))
                                        }
                                        {
                                            product.product_type === "Grouped Product" && (
                                                <p className="hbtviewproduct-modaltext" onClick={() => setShowGroupedModal(true)}>View Product</p>
                                            )
                                        }
                                        {(product.product_type === "Grouped Product" && groupedModal) && (
                                            <GroupedProductsModal products={(product.product_id)} onClose={() => setShowGroupedModal(false)}

                                            />
                                        )}



                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            )}
            <ToastContainer />
        </>
    );
};

export default OrderUpdatedVersionCards;


function GroupedProductsModal({ products, title = "Products", onAddToCart, onClose }) {
    console.log(products)
    const [singleProduct, setProducts] = useState({})
    // if (!Array.isArray(products) || products.length === 0) return null;

    // const normalized = products.map((p) => ({
    //     id: p.product_id || p.id,
    //     title: p.title || 'Untitled',
    //     image: p.imageUrl || p.image || '/default-image.jpg',
    //     discountPrice: p.salePrice || p.discountPrice,
    //     originalPrice: p.price || p.originalPrice,
    //     inStock: (p.stock ?? p.totalStock ?? 0) > 0,
    // }));

    const url = process.env.REACT_APP_LINK
    const singleProductdata = async () => {
        try {
            const response = await fetch(`${url}/grouped-product/single/${products}`);
            const res = await response.json();

            const safeParse = (value, fallback = []) => {
                try {
                    return typeof value === "string" ? JSON.parse(value) : value || fallback;
                } catch (e) {
                    return fallback;
                }
            };

            const parsed = {
                ...res,
                gallery: safeParse(res.gallery),
                specifications: safeParse(res.specifications),
                key_features: safeParse(res.key_features),
                variation: safeParse(res.variation),
                attribute: safeParse(res.attribute)
            };
            setProducts(parsed);
            console.log(parsed)

        } catch (error) {
            console.error("Error fetching product:", error);
        }
    };


    useEffect(() => {
        singleProductdata();

    }, [])
    const groupedProducts = safeParseJson(singleProduct.grouped_product)
    console.log(groupedProducts)
    return (
        <div className="modal-overlayhbt">
            <div className="modal-boxhbt">
                <div className="modal-headerhbt">
                    <h2>{title}</h2>
                    <button className="close-btnhbt" onClick={onClose}>&times;</button>
                </div>

                {/* <h3 className="section-titlehbt">Starters</h3> */}

                <div className="modal-listhbt">
                    {groupedProducts.map((p, idx) => (
                        <motion.div
                            key={p.id || idx}
                            className="modal-itemhbt"
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: idx * 0.05 }}
                        >
                            <div className="indicatorhbt" style={{ backgroundColor: p.inStock ? '#3152f4' : '#3152f4' }}></div>
                            <div className="item-titlehbt">{p.title}</div>
                            <img
                                src={`${url}${p.image ? p.image : p.imageUrl}`}
                                alt={p.title}
                                className="item-imagehbt"
                            />
                        </motion.div>
                    ))}
                </div>
                <button className="primary-btnhbt" onClick={onClose}>Close</button>

            </div>
        </div>
    );
}